import React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";
import { Info } from "lucide-react";

/**
 * Small ⓘ icon next to a label that reveals a one-sentence explanation on hover/focus.
 * Usage: <InfoTooltip text="Grace minutes after start time before flagging late." />
 */
export default function InfoTooltip({ text, testid }) {
    if (!text) return null;
    return (
        <TooltipProvider delayDuration={150}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <button
                        type="button"
                        aria-label="More info"
                        data-testid={testid || "info-tooltip"}
                        className="inline-flex items-center justify-center align-middle text-[color:var(--asl-muted)] hover:asl-navy-text transition ml-1"
                    >
                        <Info className="h-3.5 w-3.5" />
                    </button>
                </TooltipTrigger>
                <TooltipContent className="max-w-xs text-[11px] leading-snug">
                    {text}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
